import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAuth0, authHttpInterceptorFn } from '@auth0/auth0-angular';
import { routes } from './app.routes';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authHttpInterceptorFn])),
    provideAuth0({
      domain: environment.auth0Domain,
      clientId: environment.auth0ClientId,
      authorizationParams: {
        ...(environment.auth0Audience ? { audience: environment.auth0Audience } : {}),
        scope: 'openid profile email',
        redirect_uri: window.location.origin + '/callback'
      },
      httpInterceptor: {
        allowedList: environment.auth0Audience ? [{ uri: `${environment.apiBaseUrl}/*` }] : []
      }
    })
  ]
};
